module.exports = __webpack_public_path__ + "static/media/airport.4314832c.svg";